import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BackOfficeService } from '../../../../../services/backoffice.service';

@Component({
  selector: 'app-route-schedule-resolve',
  templateUrl: './route-schedule-resolve.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class RouteScheduleResolveComponent {
  slotOptions: string[];
  selectedSlot: string = null;
  notifyCustomer = false;
  saving = false;
  error: string = null;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { routeName: string, time: string, shuttleIds: string[], shuttleCount: number, slotOptions: string[] },
    private dialogRef: MatDialogRef<RouteScheduleResolveComponent>,
    private backofficeService: BackOfficeService,
  ) {
    this.slotOptions = data.slotOptions;
  }

  selectSlot(slot: string) {
    this.selectedSlot = slot;
  }

  confirm() {
    if (!this.selectedSlot || this.saving) return;

    this.error = null;
    this.saving = true;
    this.backofficeService.rescheduleShuttles(this.data.shuttleIds, this.selectedSlot, this.notifyCustomer).subscribe({
      next: (result: any) => {
        this.saving = false;
        this.dialogRef.close({
          success: true,
          slot: this.selectedSlot,
          resolvedCount: result?.resolvedCount ?? 0,
          failedCount: result?.failedCount ?? 0
        });
      },
      error: (err) => {
        this.saving = false;
        this.error = (typeof err?.error === 'string' && err.error) || 'Could not reschedule the shuttles';
      }
    });
  }

  close() {
    this.dialogRef.close();
  }
}
